import React from 'react';
import { SiriusHtmlModal } from '@web-common/components/UI/Modal/SiriusModal';
import MailValidate from '../validate/mail';
import styles from './bindAccount.module.scss';
import { useActions } from '@web-common/state/createStore';
import { actions as LoginActions } from '@web-common/state/reducer/loginReducer';
import { getIn18Text } from 'api';
import { jumpToRedirectUrl, safeDecodeURIComponent } from '@web-common/utils/utils';
const MailBindModal = props => {
    const { from, visible, title = getIn18Text('BANGDINGNINDEWANG'), onBack, defaultAccount, currentAccountNode, visibleModal = true, type } = props;
    const { setMailBindModalInfo } = useActions(LoginActions);
    const onSuccess = () => {
        if (!type || type === 'common') {
            if (/(?:^|\?|&)(?:redirectUrl|redirect_url)=([^&#]+)/.test(location.search)) {
                const url = safeDecodeURIComponent(RegExp.$1);
                jumpToRedirectUrl(url);
                return;
            }
        }
        window.location.assign('/');
    };
    const renderWrap = () => visible ? (React.createElement("div", { className: styles.wrap },
        !visibleModal && onBack && (React.createElement("div", { className: styles.back, onClick: onBack }, getIn18Text('FANHUI'))),
        React.createElement("div", { className: styles.title }, title),
        React.createElement(MailValidate, { defaultAccount: defaultAccount, from: from, currentAccountNode: currentAccountNode, onSuccess: onSuccess }))) : null;
    return !visibleModal ? (renderWrap()) : (React.createElement(SiriusHtmlModal, { visible: visible, width: 476, onCancel: () => setMailBindModalInfo({ visible: false, account: '' }) }, renderWrap()));
};
export default MailBindModal;
